<template>
	<div class="container">
		<div class="main">
			<div class="content">
				<div class="circle-title" v-if="userId">我的圈子<span class="circle-title-bg"></span></div>
				<div class="circle-type" v-if="userId">
					<div class="circle-list-wrap" v-if="joinCircleList.length>4&&joinMoreClick==1">
						<div class="circle-list" @click="toCircleIndex(item.id)" v-for="(item, index) in joinCircleList" :key="index">
							<div class="circle-list-l" @click="toCircleDetail(item.id)">
								<img :src="item.icon||require('@/assets/default-img.png')"/>
								<div v-if="item.newPushPostCount" class="icon-circle">{{item.newPushPostCount}}</div>
							</div>
							<div class="circle-list-r" @click="toCircleDetail(item.id)">
								<h3 >{{item.circleName}}</h3>
								<div class="circle-num">{{item.postNum}}帖子</div>
							</div>
						</div>
					</div>
					<div class="circle-list-wrap" v-else>
						<div class="circle-list" @click="toCircleIndex(item.id)" v-for="(item, index) in joinCircleList" v-if="index<4" :key="index">
							<div class="circle-list-l">
								<img :src="item.icon||require('@/assets/default-img.png')"/>
								<div v-if="item.newPushPostCount" class="icon-circle">{{item.newPushPostCount}}</div>
							</div>
							<div class="circle-list-r">
								<h3>{{item.circleName}}</h3>
								<div class="circle-num">{{item.postNum}}帖子</div>
							</div>
						</div>
					</div>
					<div class="circle-list-more" v-if="joinCircleList.length>4&&joinMoreClick==0" @click="showJoinMore">
						查看更多({{joinCircleList.length-4}})<i class="el-icon-caret-bottom"></i>
					</div>
				</div>
				<div class="circle-title">全部圈子<span class="circle-title-bg"></span></div>
				<div class="circle-type circle-all" v-for="(item, index) in allCircleList" :key="index">
					<h1>{{item.categoryName}}</h1>
					<div class="circle-list-wrap" v-if="item.list.length>8&&item.isclick==1">
						<div class="circle-list" @click="toCircleIndex(itemList.id)" v-for="(itemList, itemIndex) in item.list" :key="itemIndex">
							<div class="circle-list-l">
								<img :src="itemList.icon||require('@/assets/default-img.png')"/>
							</div>
							<div class="circle-list-r">
								<h3>{{itemList.circleName}}</h3>
								<div class="circle-num">{{itemList.postNum}}帖子</div>
							</div>
						</div>
					</div>
					<div class="circle-list-wrap" v-else>
						<div class="circle-list" @click="toCircleIndex(itemList.id)" v-for="(itemList, itemIndex) in item.list" :key="itemIndex" v-if="itemIndex<8">
							<div class="circle-list-l">
								<img :src="itemList.icon||require('@/assets/default-img.png')"/>
							</div>
							<div class="circle-list-r">
								<h3>{{itemList.circleName}}</h3>
								<div class="circle-num">{{itemList.postNum}}帖子</div>
							</div>
						</div>
					</div>
					<div class="circle-list-more" v-if="item.list.length>8&&item.isclick==0" @click="showCircleMore(index)">
						查看更多({{item.list.length-8}})<i class="el-icon-caret-bottom"></i>
					</div>
				</div>
				
			</div>
			<div class="aside">
				<asideNews/>
				<asideCircle/>
			</div>
		</div>
	</div>
</template>

<script>
	import banner from '../home/banner'
	import articleCard from '@/components/articleCard'
	import asideNews from '@/components/aside/news'
	import asideCircle from '@/components/aside/recommendCircle'
	import asideFollow from '@/components/aside/recommendFollow'
	import asideActive from '@/components/aside/activeUser'
	import circleRecommend from './recommend'
	import circleNews from './recommendNews'
	import Pagination from '@/components/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'circleHome',
		components: {
			banner,
			articleCard,
			asideNews,
			asideCircle,
			asideFollow,
			asideActive,
			circleRecommend,
			circleNews
		},
		data(){
			return {
				activeTab: 'all',
				activeIndex: 0,
				navList: [],
				categoryId: '',
				pageNum: 1,
				pageSize: 10,
				dataList: [],
				recommendFlag: '', //是否推荐 1推荐 0否 不传查全部
				total: 0,
				userId: '',
				searchKeyWord: '',
				joinCircleList: [],
				allCircleList: [],
				joinMoreClick: 0
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')
			this.getNavList()
			if(this.userId) {
				this.getCircleCategory()
			}
			this.getAllCircleList()
		},
		methods: {
			//获取加入圈子
			async getCircleCategory(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircleList', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					this.joinCircleList = list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取全部圈子新接口
			async getAllCircleList(){
				let param = {
					userId: this.userId
				}
				ajaxParam(param)
				const res = await post('v1/circle/allCircleList', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					list.forEach(item=>{
						item.isclick = 0
					})
					this.allCircleList = list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取圈子分类数据
			async getNavList(){
				let param = {}
				ajaxParam(param)
				const res = await post('v1/circle/circleCategory', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					this.navList = res.data.list
					if(this.navList.length>0) {
						this.categoryId = this.navList[0].id
						this.getDataList()
					}
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取圈子数据列表
			async getDataList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					categoryId: this.categoryId,
					recommendFlag: this.recommendFlag,
					userId: this.userId,
					searchKeyWord: this.searchKeyWord
				}
				ajaxParam(param)
				const res = await post('v1/circle/circleList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toCircleIndex(id){
				this.$router.push({
					path: '/circleIndex?id='+id
				})
			},
			toCircleDetail(id){
				this.$router.push({
					path: '/circleIntroduce?id='+id
				})
			},
			toChangeNav(id, index){
				this.activeIndex = index
				this.categoryId = id
				this.dataList = []
				this.recommendFlag = ''
				this.pageNum = 1
				console.log(this.categoryId)
				this.getDataList()
			},
			toRecommend(){
				this.activeIndex = -1
				this.categoryId = ''
				this.recommendFlag = 1
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			handleClick(tab, event) {
				this.searchType = tab.name
				// if(this.searchType=='all'){
				// 	this.searchType = ''
				// }
				// this.dataList = []
				// this.pageNum = 1
				// this.getDataList()
			},
			async toEnter(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					circleId: item.id,
					circleIds: ''
				}
				ajaxParam(param)
				const res = await post('v1/circle/joinCircle', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					this.$message.success('加入成功！')
					item.isJoin = 1
				} else {
					this.$message.error(res.data.msg)
				}
			},
			async toUnEnter(item){
				if(!this.userId){
					this.$router.push({
						path: '/login'
					})
					return
				}
				let param = {
					userId: this.userId,
					circleId: item.id
				}
				ajaxParam(param)
				const res = await post('v1/circle/quitCircle', qs.stringify(param))
				if(res.data.code==200){
					this.$message.success('退出成功！')
					item.isJoin = 0
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toSearch(e){
				this.searchKeyWord = e
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			showCircleMore(index){
				this.allCircleList.forEach((item, itemIndex)=>{
					if(index == itemIndex){
						item.isclick = 1
					}
				})
			},
			showJoinMore(){
				this.joinMoreClick = 1
			}
		}
	}
</script>

<style scoped lang="less">
	.main{
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		width: 1180px;
		margin: 20px auto;
		.content{
			flex: 1;
			background: #fff;
			padding: 20px 30px;
			border-radius: 10px;
			.circle-nav{
				width: 180px;
				font-size: 16px;
				line-height: 40px;
				h3{
					font-weight: bold;
          cursor: pointer;
				}
        h3.active{
          color: #DD0515;
          font-weight: bold;
        }
				ul{
					opacity: .7;
					li{
						cursor: pointer;
					}
					li.active{
						color: #DD0515;
						font-weight: bold;
					}
				}
			}
			.circle-cnt{
				flex: 1;
				border-left: 1px solid rgba(50,50,51,.14);
				.el-input{
					width: 300px;
					margin-left: 20px;
					margin-bottom: 20px;
				}
				/deep/ .el-input__inner {
					height: 30px;
					line-height: 30px;
					border-radius: 16px;
				}
				/deep/ .el-input-group__append{
					padding: 0 10px
				}
				/deep/ .el-input__inner:focus{
					border-color: #DCDFE6
				}
				/deep/ .el-input__icon{
					line-height: 30px;
				}
			}
			.circle-title{
				height: 40px;
				border-bottom: 1px solid rgba(50, 50, 51, 0.14);
				line-height: 40px;
				font-weight: bold;
				position: relative;
				margin-bottom: 15px;
				.circle-title-bg{
					position: absolute;
					left: 0;
					bottom: 0;
					width: 56px;
					height: 4px;
					background: #DD0515;
				}
			}
			.circle-all{
				margin-bottom: 15px;
				border-bottom: 1px solid rgba(50, 50, 51, 0.14);
			}
			.circle-all:last-of-type{
				margin-bottom:0;
				border-bottom: none;
			}
			.circle-type{
				padding-bottom: 15px;
				h1{
					//margin: 15px 0 0;
					font-size: 12px;
					color: #666;
					opacity: .6;
				}
			}
			.circle-list-wrap{
				display: flex;
				flex-wrap: wrap;
				margin-top: 8px;
				.circle-list{
					display: flex;
					align-items: center;
					width: 25%;
					margin-bottom: 10px;
					padding: 0 10px;
					cursor: pointer;
					box-sizing: border-box;
					.circle-list-l{
						position:relative;
						.icon-circle{
							width:14px;
							height: 14px;
							background: #DD0515;
							border-radius: 50%;
							line-height: 14px;
							text-align: center;
							font-size: 12px;
							color:#fff;
							position: absolute;
							right: 0;
							top: 0
						}
						img{
							width: 50px;
							height: 50px;
							margin: 0 auto;
							border-radius: 15px;
						}
					}
					.circle-list-r{
						margin-left: 10px;
						overflow: hidden;
						h3{
							width: 100%;
							font-size: 14px;
							font-weight: bold;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							text-align: center;
							line-height: 30px;
						}
						.circle-num{
							margin: 4px 0 10px;
							opacity: .7;
							font-size: 12px;
						}
					}
					
					.enter-btn{
						width: 62px;
						height: 22px;
						border-radius: 14px;
						border: 1px solid #DD0515;
						line-height: 22px;
						text-align: center;
						font-size: 12px;
						color: #DD0515;
					}
					.entered{
						background: rgba(50,50,50,.1);
						border-color: rgba(50,50,50,.1);
						color: rgba(50,50,50,.3);
					}
				}
			}
			.circle-list-more{
				text-align: center;
				color: rgba(14,21,28,.3);
				cursor: pointer;
			}
		}
		.aside{
			width: 300px;
			margin-left: 20px;
		}
	}
</style>
